import { jwtDecode } from 'jwt-decode';

const getJwtExpiry = (token) => {
  if (!token) {
    return null;
  }
  try {
    const decodedToken = jwtDecode(token);
    // The 'exp' claim is a Unix timestamp (seconds since epoch)
    // Convert it to milliseconds for a JavaScript Date object
    return new Date(decodedToken.exp * 1000);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};
export default getJwtExpiry;
